import {UseCase} from '@s-ui/domain'

export class GetAdvertisementsTrackingService extends UseCase {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.fromPageTrackingJsonToAdvertisementsValueObjectMapper
   */
  constructor({fromPageTrackingJsonToAdvertisementsValueObjectMapper}) {
    super()

    this._fromPageTrackingJsonToAdvertisementsValueObjectMapper = fromPageTrackingJsonToAdvertisementsValueObjectMapper
  }

  /**
   * @param {Object} param
   * @param {Object} param.ads
   * @param {Object} param.ad - MONOLITH
   * @param {Object} param.similarAds - MONOLITH
   * @param {Object} param.adsTypeName
   * @param {Object} param.context
   * @param {Object} param.filters
   */
  execute = async ({ads = [], ad, similarAds = [], adsTypeName, context, listType, filters}) => {
    const adsArray = [ad && ad, ...similarAds, ...ads].filter(Boolean)

    return this._fromPageTrackingJsonToAdvertisementsValueObjectMapper
      .setParams({adsTypeName, context, listType})
      .map({ads: adsArray, filters})
  }
}
